export const INIT_BUYCART = 'INIT_BUYCART'
export const CHANGE_META_INFO = 'CHANGE_META_INFO'
export const INDEX_FIRSTLIST = 'INDEX_FIRSTLIST'
export const INIT_NEWMESSAGELIST = 'INIT_NEWMESSAGELIST'
export const INIT_ZHIBO = 'INIT_ZHIBO'
export const RE_ZHIBO = 'RE_ZHIBO'
export const DES_ZHIBO = 'DES_ZHIBO'
export const INIT_BAOEN_TREE = 'INIT_BAOEN_TREE'
export const DES_BAOEN_TREE = 'DES_BAOEN_TREE'
export const SET_COUNTRYCODE = 'SET_COUNTRYCODE'
export const GET_BAOEN_LIST = 'GET_BAOEN_LIST'
export const QUERY_BAOEN_LIST = 'QUERY_BAOEN_LIST'
export const QUERY_BAOEN_ALL_LIST = 'QUERY_BAOEN_ALL_LIST'
export const PAGECHANGE = 'PAGECHANGE'
export const RELOADVIDEO = 'RELOADVIDEO'
export const ADD_CART = 'ADD_CART'
export const GET_USERINFO = 'GET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const ADD_ANIMATION = 'ADD_ANIMATION'
export const SHOW_CART = 'SHOW_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const EDIT_CART = 'EDIT_CART'
export const INIT_PLAYER = 'INIT_PLAYER'
export const DES_PLAYER = 'DES_PLAYER'
export const INIT_PLAYER_MP3 = 'INIT_PLAYER_MP3'
export const PLAYER_NEXT_SECTION = 'PLAYER_NEXT_SECTION'
export const ENLIGHT_LIST = 'ENLIGHT_LIST'
export const ENLIGHT_LIST_OPEN = 'ENLIGHT_LIST_OPEN'
export const ENLIGHT_LOADING = 'ENLIGHT_LOADING'
export const ENLIGHT_INFO = 'ENLIGHT_INFO'
export const ENLIGHT_INFO_LOADING = 'ENLIGHT_INFO_LOADING'
export const FS_RIGHT_INFO_LOADING = 'FS_RIGHT_INFO_LOADING'
export const MOBAO_CATEGORY = 'MOBAO_CATEGORY'
export const MOBAO_CATEGORY_LOADING = 'MOBAO_CATEGORY_LOADING'
export const MOBAO_LIST = 'MOBAO_LIST'
export const MOBAO_LIST_LOADING = 'MOBAO_LIST_LOADING'
export const MOBAO_CATEGORY_CHANCE = 'MOBAO_CATEGORY_CHANCE'
export const IMG_INDEX = 'IMG_INDEX'
export const EBOOK_SEARCH = 'EBOOK_SEARCH'
export const RSFS_INDEX2 = 'RSFS_INDEX2'
export const RSFS_TYPELIST = 'RSFS_TYPELIST'
export const RSFS_INFO = 'RSFS_INFO'
export const RSFS_EXINFO = 'RSFS_EXINFO'
export const ENLIGHT_INDEX = 'ENLIGHT_INDEX'
export const ENLIGHT_PAGE = 'ENLIGHT_PAGE'
export const QUERY_ENLIGHT_LIST = 'QUERY_ENLIGHT_LIST'
export const EBOOK_PAGE = 'EBOOK_PAGE'
export const EBOOK_INDEX = 'EBOOK_INDEX'
export const EBOOK_TREE_LOADING = 'EBOOK_TREE_LOADING'
export const CARD_INDEX = 'CARD_INDEX'
export const CARD_PAGE = 'CARD_PAGE'
export const CARD_DOWN = 'CARD_DOWN'
export const CARD_INDEX_NEW = 'CARD_INDEX_NEW'
export const CARD_PAGE_NEW = 'CARD_PAGE_NEW'
export const CARD_DOWN_NEW = 'CARD_DOWN_NEW'
export const WALLCARD_LIST_LOADING = 'WALLCARD_LIST_LOADING'
export const INIT_PLAYER_ORDER = 'INIT_PLAYER_ORDER'
export const INIT_PLAYER_MP3_ORDER = 'INIT_PLAYER_MP3_ORDER'
export const CHANGE_ZHIBO_LIST = 'CHANGE_ZHIBO_LIST'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js